import React, {Fragment} from 'react';
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
import axios from "axios";
import magnifier from '../../assets/magnifier.svg';
import {isMobileOnly} from "react-device-detect";
import Dropdown from 'react-dropdown';
import "./c73_courses_prefiltered.scss";
import {API_CONFIG} from '../../config/api_config';
import LuissButton from "../../common_components/luiss_button/luiss_button";

const SVG_ID = "#svg_id";

class C73CoursesPrefiltered extends DoubleTemplateComponent {
    department = '';

    constructor(props) {
        super(props);
        this.state = {
            load_more_url: "",
            courses: [],
            isHidden: true,
            searchfor: '',
            optionDepartment: [],
            arrayCallCat: []
        };
        this.requireInternationalization = true;
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadTaxonomy();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);
        if (this.props.language !== prevProps.language) {
            this.loadTaxonomy();
        }
    };

    loadTaxonomy() {
        // create select options before render html elements
        const epCategory = `${API_CONFIG.BASE_URL}/terms/${this.props.language}/dipartimento`;
        axios.get(epCategory).then(res => {
            let terms = res.data.terms;
            terms.sort(function (a, b) {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            })
            this.setState({
                optionDepartment: terms.map(el => el.label),
                arrayCallCat: terms
            });
            this.state.optionDepartment.unshift('All');
        })
    }

    changeDepartment = selected => {
        selected = selected.value;
        this.getValDepartment(selected);
        if (selected === 'All') {
            selected = '';
            this.department = '';
            this.callFilter();
        }

        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.arrayCallCat.forEach((filterString) => {
            for (var key in filterString) {
                if (filterString[key] === selected) {
                    this.department = filterString.id;
                    return this.callFilter();
                }
            }
        })
    };

    onSubmit = event => {
        event.preventDefault();
        this.callFilter();
    };

    onChangeSearch = event => {
        let search = event.target.value;
        this.setState({searchfor: search});
    }

    getValDepartment = val => {
        this.setState({valueDep: val});
    };

    callFilter = () => {
        console.log("1: ", this.state.courses)
        let params = {};
        if (this.state.searchfor !== '') {
            params['search'] = this.state.searchfor;
        }
        let department = this.department;
        if (department) {
            params['department'] = department;
            this.setState({
                filterDepartment: department
            })
        } else {
            this.setState({
                filterDepartment: ''
            })
        }
        if (document.forms.searchForm && document.forms.searchForm.search && document.forms.searchForm.search.value) {
            params['search'] = document.forms.searchForm.search.value;
        }
        axios.get(this.state.data.__data, {params: params}).then(res => {
            this.setState({
                courses: res.data.items,
                searchTerm: res.data.title
            });
        });
    };

    showMore = ep => {
        axios.get(ep, {}).then(res => {
            let newItems = this.state.courses.concat(res.data.items);

            this.setState({
                courses: newItems,
                load_more_url: res.data.next_page
            });
        });
    };

    onDataLoaded = data => {
        this.setState({
            load_more_url: data.next_page,
            courses: data.items
        });
    };

    internationalComponentRender(allData, t) {
        const {isHidden, valueDep} = this.state;

        return (
            <Fragment>
                <div id={!isMobileOnly ? "courses-prefiltered-grid" : "courses-prefiltered-grid-mob"}
                     className="container-fluid c73-courses-prefiltered">
                    <div id={!isMobileOnly ? "" : "courses-prefiltered-row-mob"} className="row">
                        <div className={isMobileOnly ? "" : "col-4"}>
                            <Dropdown options={this.state.optionDepartment} onChange={this.changeDepartment} value={valueDep} placeholder="All"
                                      className='c73-Dropdown'/>
                        </div>
                        <div className={isMobileOnly ? "" : "col-4"}>
                            <form onSubmit={this.onSubmit} name="newsSearch"
                                  className={!isMobileOnly ? 'search-bar-courses_prefiltered' :
                                      (!isHidden ? 'search-bar-courses_prefiltered' : "search-bar-courses_prefiltered text-right")}>
                                <button className="courses_prefiltered-search-button" onClick={this.showSearchField}>
                                    <svg className="magnifier-courses_prefiltered">
                                        <use xlinkHref={`${magnifier}${SVG_ID}`}/>
                                    </svg>
                                </button>
                                <input name="search" className="search-input" onChange={this.onChangeSearch} value={this.searchfor}/>
                            </form>
                        </div>
                    </div>
                    {this.state.courses.length > 0 ? <Fragment>
                        <div className="c25-box-course h-listing">
                            {this.state.courses.map((value, i) => (
                                <a className='link-box h-product h-course u-url' href={value.url} key={"course-box-" + i}>
                                    <div className="box-course course-details">
                                        <h2 className="title p-name" style={{color: (value.color ? value.color : "#010101")}}>{value.title}</h2>
                                        <p className="category-type p-category">{value.category}</p>
                                        {value.language && <p key={"lang-" + i} className="language-txt">{value.language}
                                            {value.language === "English" && <span><img src="/english.svg" alt="english"/></span>}
                                        </p>}
                                        {value.majors && <div className="major-container">
                                            {value.majors.map((item) => (
                                                <p key={`${value.title}-${item.title}`} className="language-txt">{item.title}
                                                    {item.language === "en" && <span><img src="/english.svg" alt="english"/></span>}
                                                </p>
                                            ))}
                                        </div>}
                                    </div>
                                </a>
                            ))}
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center">
                                    {this.state.load_more_url !== "" ?
                                        <LuissButton ep={this.state.load_more_url} action={this.showMore}>Carica altro</LuissButton> : null}
                                </div>
                            </div>
                        </div>
                    </Fragment> : <div className={'row not-found mt-5'}>{t("C73 no content")}</div>}
                </div>
            </Fragment>
        );
    }
}

export default C73CoursesPrefiltered;
